<template>
    <tr :key="index">
        <td>
            <x-remove-button @click.prevent="handleRemove" />
        </td>
        <td>
            <x-form-group :error="getNamespacedError(`rules.${index}.operator`)"
                v-show="showOperator">
                <select class="form-control" v-model="rule.operator">
                    <option v-for="(operator, index) in availableOperators" :key="index" :value="operator.key">
                        {{ operator.label }}
                    </option>
                </select>
            </x-form-group>
        </td>
        <td>
            <x-form-group :error="getNamespacedError(`rules.${index}.type`)">
                <select class="form-control" v-model="rule.type">
                    <option v-for="(comparator, index) in availableComparators" :key="index" :value="comparator.key">
                        {{ comparator.label }}
                    </option>
                </select>
            </x-form-group>
        </td>
        <td>
            <x-form-group :error="getNamespacedError(`rules.${index}.value`)">
                <input type="text"
                    class="form-control"
                    v-model="rule.value"
                    v-if="valueIsText" />
                <input type="number"
                    class="form-control"
                    v-model="rule.value"
                    v-if="valueIsNumber" />
                <template v-if="valueIsOptions">
                    <multiselect open-direction="bottom"
                        v-model="rule.value"
                        placeholder="Pilih option"
                        :options="availableOptions"
                        class="form-control"
                        v-if="availableOptions.length > 0" />
                    <span class="help-block" v-else>
                        Tambahkan option terlebih dulu
                    </span>
                </template>
            </x-form-group>
        </td>
        <td v-if="allowSubRules">
            <button @click.prevent="$emit('addSubRule', $event)" 
                class="btn btn-link no-disabler"
                title="Add sub-rule">
                <i class="fa fa-plus-circle"></i>
            </button>
        </td>
    </tr>
</template>

<script>
import XFormGroup from '../../components/XFormGroup.vue'
import XRemoveButton from '../../components/XRemoveButton.vue'
import FormErrorMixin from '../../mixins/FormErrorMixin'
import { types } from './constants'
export default {
    components: { XRemoveButton, XFormGroup },
    computed: {
        valueIsText() {
            return this.type === types.text
        },
        valueIsNumber() {
            return this.type === types.age
                || this.type === types.number
        },
        valueIsOptions() {
            return this.type === types.checkbox
                || this.type === types.radio
        },
    },
    created() {
        this.rule = {
            ...this.rule,
            ...this.value,
        }
    },
    data() {
        return {
            rule: {
                operator: _.get(this.availableOperators, '0.key', null),
                type: _.get(this.availableComparators, '0.type', null),
                value: null,
            }
        }
    },
    methods: {
        getNamespacedError(key) {
            const namespacedKey = this.errorNamespace
                ? `${this.errorNamespace}.${key}`
                : key
            return this.getError(namespacedKey)
        },
        handleRemove() {
            this.$emit('remove', this.index)
        },
    },
    mixins: [
        FormErrorMixin,
    ],
    props: {
        allowSubRules: {
            type: Boolean,
            required: false,
            default: false,
        },
        availableComparators: {
            type: Array,
            required: true,
        },
        availableOperators: {
            type: Array,
            required: true,
        },
        availableOptions: {
            type: Array,
            required: false,
            default: () => [],
        },
        errorNamespace: {
            type: String,
            required: false,
            default: null,
        },
        index: {
            type: Number,
            required: true,
        },
        showOperator: {
            type: Boolean,
            required: false,
            default: true,
        },
        type: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
    watch: {
        rule: {
            handler(rule) {
                this.$emit('input', rule)
            },
            deep: true,
        },
    }
}
</script>